import styled from 'styled-components';

export const FooterWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const WarningWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: ${props => props.theme.spacing.medium};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.small};
  svg {
    path {
      fill: ${props => props.theme.color.primary};
    }
  }
`;
